module.exports = __webpack_public_path__ + "static/media/document.cd9aee82.svg";